import { AccountType, ITrade } from './types'
import {
  FormFile, isFileProvide, hasUploadedFile,
  Flexible, Fillable,
} from './Form'
import { isCountryTaiwan } from './FormFields'
import { DealingMultiForm } from './v3/types'

export enum FormFiles {
  /** FAOL_GCMF 非美國人之認購申請表_U13_互動版 */
  Application_SBS_GCMF = 'Application_SBS_GCMF',
  /** FOL_SOF 非美國人之認購申請表_U13_互動版 */
  Application_SBS_SOF = 'Application_SBS_SOF',
  /** FOL_UGWAF 非美國人之認購申請表_U13_互動版 */
  Application_SBS_UGWAF = 'Application_SBS_UGWAF',
  /** FAOL_GCMF 贖回申請表_U9_互動版 */
  Application_RDM_GCMF = 'Application_RDM_GCMF',
  /** FOL_SOF 贖回申請表_U9_互動版 */
  Application_RDM_SOF = 'Application_RDM_SOF',
  /** FOL_UGWAF 贖回申請表_U9_互動版 */
  Application_RDM_UGWAF = 'Application_RDM_UGWAF',
  /** FAOL_GCMF to FOL_SOF 轉換表單_互動版 */
  Application_SWITCH_GCMF_SOF = 'Application_SWITCH_GCMF_SOF',
  /** FAOL_GCMF to FOL_UGWAF 轉換表單_互動版 */
  Application_SWITCH_GCMF_UGWAF = 'Application_SWITCH_GCMF_UGWAF',
  /** FOL_SOF to FAOL_GCMF 轉換表單_互動版  */
  Application_SWITCH_SOF_GCMF = 'Application_SWITCH_SOF_GCMF',
  /** FOL_SOF to FOL_UGWAF 轉換表單_互動版  */
  Application_SWITCH_SOF_UGWAF = 'Application_SWITCH_SOF_UGWAF',
  /** FOL_UGWAF to FAOL_GCMF 轉換表單_互動版 */
  Application_SWITCH_UGWAF_GCMF = 'Application_SWITCH_UGWAF_GCMF',
  /** FOL_UGWAF to FOL_SOF 轉換表單_互動版 */
  Application_SWITCH_UGWAF_SOF = 'Application_SWITCH_UGWAF_SOF',

  /** BPN 綜合交易表單 */
  Application_SBS_BNP = 'Application_SBS_BNP',
  Application_RDM_BNP = 'Application_RDM_BNP',
  Application_Switch_BNP = 'Application_Switch_BNP',

  /** 
   * 轉換空白表單
   * @see https://app.asana.com/0/0/1205810213745320/f
   */

  /** FAO to FOL 轉換表單_互動版 */
  Application_SWITCH_FAOL_FOL = 'Application_SWITCH_FAOL_FOL',
  /** FOL to AOL 轉換表單_互動版 */
  Application_SWITCH_FOL_FAOL = 'Application_SWITCH_FOL_FAOL',
  /** FAOL to FAOL 轉換表單_互動版 */
  Application_SWITCH_FAOL_FAOL = 'Application_SWITCH_FAOL_FAOL',
  /** AOL to AOL 轉換表單_互動版 */
  Application_SWITCH_AOL_AOL = 'Application_SWITCH_AOL_AOL',
  /** FOL to FOL 轉換表單_互動版 */
  Application_SWITCH_FOL_FOL = 'Application_SWITCH_FOL_FOL',

  /** 特殊 UndertakingLetter: 認購人為聯名戶，「每次」贖回時，銀行帳戶選擇「單名帳戶」時 */
  UndertakingLetter = 'UndertakingLetter',

  /** 認購/贖回/轉換相關表 ApplicationFiles */
  Application = 'Application',
  /** 認購/贖回/轉換相關表 註銷文件 */
  ApplicationCancellation = 'ApplicationCancellation',
  /** 認購註銷套表 */
  Application_SBS_Cancel = 'Application_SBS_Cancel',
  /** 贖回註銷套表 */
  Application_RDM_Cancel = 'Application_RDM_Cancel',
  /** 轉換註銷套表 */
  Application_Switch_Cancel = 'Application_Switch_Cancel',
  /** 共同持有人資料明細表_互動版 */
  Shareholder = 'Shareholder',
  /** W-8BEN 表格 - 個人投資者 - 簽署版 */
  W8BEN = 'W8BEN',
  /** W-8BEN-E 表格 - 機構投資者 - 簽署版 */
  W8BEN_E = 'W8BEN_E',
  /** HSBC: Attestation Form */
  Attestation = 'Attestation',
  /** BNP: AML Supplement */
  AMLSupplement = 'KYCSupplement',
  /** Individual_Self-Certification 自我聲明表_個人投資者-簽署版 */
  SelfCertification = 'SelfCertification',
  /** Entity_Self-Certification 自我聲明表_機構投資者-簽署版 */
  SelfCertification_E = 'SelfCertification_E',
  /** HSBC: CHANGE OF PARTICULARS FORM */
  ChangeParticulars = 'ChangeParticulars',
  /** BNP: Change Wiring Instruction */
  ChangeWiringInstruction = 'ChangeWiringInstruction',
  /** BNP: Change Registration  */
  ChangeRegistration = 'ChangeRegistration',
  /** 認購匯款證明 */
  PaymentProof = 'PaymentProof',
  /** 銀行帳戶結單副本 */
  BankAccount = 'BankAccount',
  /** 護照影本 */
  Passport = 'Passport',
  /** 名稱更改證書認證副本 */
  NameChangeCertified = 'NameChangeCertified',
  /** 聯絡電話更新證明', // 建議 */
  PersonalPhoneCertified = 'PersonalPhoneCertified',
  /** 認購表上所填之地址證明 */
  PersonalAddressCertified = 'PersonalAddressCertified',
  /** 地址變更證明 */
  BusinessAddressCertified = 'BusinessAddressCertified',
  /** 公司執照影本 或 營利事業登記證 或 公司更改名稱證書 */
  BusinessLicense = 'BusinessLicense',
  /** Certificate of Good Standing 存續證明 */
  BusinessGoodStanding = 'BusinessGoodStanding',
  /** 公司章程 */
  BusinessCharter = 'BusinessCharter',
  /** 律師／會計師／發證機構／外部秘書公司所出示之證明書 Certificate of Incumbency (正本) */
  BusinessCoI = 'BusinessCoI',
  /** 相關人員之護照影本，及居住地址證明 */
  BusinessMembers = 'BusinessMembers',
  BusinessMemberPassport = 'BusinessMemberPassport',
  BusinessMemberAddress = 'BusinessMemberAddress',
  /** 董事會決議正本 */
  BusinessBoardResolution = 'BusinessBoardResolution',
  /** 董事會授權投資之決議 (Deprecated) */
  // BusinessAuthorizing = 'BusinessAuthorizing',
  /** 授權簽署人員名冊、簽名樣式以及公司章樣式 (已合併至 BusinessAuthorizing) */
  // BusinessSignatures = 'BusinessSignatures',
  /** 股權組織圖 (Deprecated) */
  // BusinessOrganization = 'BusinessOrganization',
  /** 股東名冊 */
  BusinessShareholders = 'BusinessShareholders',
  /** 董事名冊 */
  BusinessDirectors = 'BusinessDirectors',
  /** Financial Statements */
  BusinessStatements = 'BusinessStatements',
  /** 其他檔案 */
  Others = 'Others',
  /** Nominee Optional Files */
  NomineeLicense = 'NomineeLicense',
  NomineeMandate = 'NomineeMandate',
  NomineeAssurance = 'NomineeAssurance',
  NomineeSignatures = 'NomineeSignatures',
  NomineeRepresentation = 'NomineeRepresentation',
}

type FormConditionTester = (args: { form?: Flexible<DealingMultiForm>, trade?: ITrade }) => boolean
interface FileDef {
  id: FormFiles
  title: string
  description?: string
  accountTypes: AccountType[]
  /** 檔案提供方式 */
  provideMethod: 'Refill' | 'Upload'
  /** 提供此檔案需滿足條件 */
  precondition?: FormConditionTester
  /** 
   * 需要附上的情況，可組合尾綴
   * 尾綴規則 固定兩碼 [庫存狀況: +有 -無 *不限][身份別: P自然人 E法人 C需判斷公司註冊地不等於台灣]
   * 特殊尾綴 (必須在最尾端)
   *  [ ? ] 選填
   *  [ % ] 銀行資訊僅限本次交易可忽略
   * 例如：
   *  phone_number+ 代表當修改了電話，此認購人同人要有庫存才需要傳檔案
   *  source_of_funds+E 代表當修改資金來源，此認購人要有庫存，同時只針對機構帳戶需要傳檔案
   *  InactiveAccount? 代表當帳戶為無庫存時，需要傳檔案，但為選填
   */
  requireOn?: string[] | 'Initial' | 'NewAccount' | 'InactiveAccount' | 'HasFund' | 'Always' | 'Provided' | 'W8Expired' | 'None' | 'Cancel' | 'Optional' | 'Hide'
  /** 若符合 requireOn 條件，仍固定為選填檔案；若設為 requireOn = 'Optional' 則一律顯示在選填檔案 */
  optional?: boolean
  /** 主持有人代表填一份即可 */
  mainHolderOnly?: boolean
  /** 主持有人代表填一份即可 */
  shareholderOnly?: boolean
  /** 是否可以上傳多圖檔 */
  multipleImages?: boolean
  /** 是否允許多檔案 */
  multipleFiles?: boolean
  /** 檔案名稱 */
  filename?: string
  /** 是否需要提供正本 */
  requireOriginal?: 'Always' | 'NewAccount' | 'CTC'
  /** 是否需要上傳 CTC */
  requireCtc?: 'Always' | 'NewAccount' | 'Copy'
  /** 命名規則 */
  nameRule: 'Application' | 'JointShareholder' | 'Cancellation' | 'Common' | 'Original' | 'UndertakingLetter'
  /** 是否為序號敏感 */
  serialSensitive?: boolean
}

const NaturalPerson = [AccountType.Personal, AccountType.Joint]
const Company = [AccountType.Institutional]
const CompanyAndNominee = [AccountType.Institutional, AccountType.Nominee]
const Nominee = [AccountType.Nominee]
const Any = [...NaturalPerson, ...Company, ...Nominee, AccountType.UGJoint]

/** UG 聯名戶主體在 KYC 流程中需要提供、但不應因此被歸類為機構戶的文件。 */
/**
 * 取得文件規則實際使用的帳戶類型。
 * UG 聯名戶的自然人資料使用 holder index 0，文件欄位沿用個人戶規則。
 */
export function getFileRuleAccountType(accountType: AccountType, holderIndex: number): AccountType {
  if (accountType === AccountType.UGJoint) return AccountType.Personal
  return accountType
}

export const FileDefinitions: FileDef[] = [

  {
    id: FormFiles.ApplicationCancellation, title: '註銷正本', provideMethod: 'Upload', accountTypes: Any, requireOn: 'Cancel', mainHolderOnly: true,
    requireOriginal: 'Always',
    nameRule: 'Cancellation',
    serialSensitive: true,
  },

  // 舊版表單，如果之前傳過才顯示
  { id: FormFiles.Application_SBS_GCMF, title: 'FAOL_GCMF 非美國人之認購申請表_U13_互動版', provideMethod: 'Refill', accountTypes: Any, requireOn: 'None', mainHolderOnly: true, serialSensitive: true, nameRule: 'Application' },
  { id: FormFiles.Application_SBS_SOF, title: 'FOL_SOF 非美國人之認購申請表_U13_互動版', provideMethod: 'Refill', accountTypes: Any, requireOn: 'None', mainHolderOnly: true, serialSensitive: true, nameRule: 'Application' },
  { id: FormFiles.Application_SBS_UGWAF, title: 'FOL_UGWAF 非美國人之認購申請表_U13_互動版', provideMethod: 'Refill', accountTypes: Any, requireOn: 'None', mainHolderOnly: true, serialSensitive: true, nameRule: 'Application' },
  { id: FormFiles.Application_RDM_GCMF, title: 'FAOL_GCMF 贖回申請表_U9_互動版', provideMethod: 'Refill', accountTypes: Any, requireOn: 'None', mainHolderOnly: true, serialSensitive: true, nameRule: 'Application' },
  { id: FormFiles.Application_RDM_SOF, title: 'FOL_SOF 贖回申請表_U9_互動版', provideMethod: 'Refill', accountTypes: Any, requireOn: 'None', mainHolderOnly: true, serialSensitive: true, nameRule: 'Application' },
  { id: FormFiles.Application_RDM_UGWAF, title: 'FOL_UGWAF 贖回申請表_U9_互動版', provideMethod: 'Refill', accountTypes: Any, requireOn: 'None', mainHolderOnly: true, serialSensitive: true, nameRule: 'Application' },
  { id: FormFiles.Application_SWITCH_GCMF_SOF, title: 'FAOL_GCMF to FOL_SOF 轉換表單_互動版', provideMethod: 'Refill', accountTypes: Any, requireOn: 'None', mainHolderOnly: true, serialSensitive: true, nameRule: 'Application' },
  { id: FormFiles.Application_SWITCH_GCMF_UGWAF, title: 'FAOL_GCMF to FOL_UGWAF 轉換表單_互動版', provideMethod: 'Refill', accountTypes: Any, requireOn: 'None', mainHolderOnly: true, serialSensitive: true, nameRule: 'Application' },
  { id: FormFiles.Application_SWITCH_SOF_GCMF, title: 'FOL_SOF to FAOL_GCMF 轉換表單_互動版 ', provideMethod: 'Refill', accountTypes: Any, requireOn: 'None', mainHolderOnly: true, serialSensitive: true, nameRule: 'Application' },
  { id: FormFiles.Application_SWITCH_SOF_UGWAF, title: 'FOL_SOF to FOL_UGWAF 轉換表單_互動版 ', provideMethod: 'Refill', accountTypes: Any, requireOn: 'None', mainHolderOnly: true, serialSensitive: true, nameRule: 'Application' },
  { id: FormFiles.Application_SWITCH_UGWAF_GCMF, title: 'FOL_UGWAF to FAOL_GCMF 轉換表單_互動版', provideMethod: 'Refill', accountTypes: Any, requireOn: 'None', mainHolderOnly: true, serialSensitive: true, nameRule: 'Application' },
  { id: FormFiles.Application_SWITCH_UGWAF_SOF, title: 'FOL_UGWAF to FOL_SOF 轉換表單_互動版', provideMethod: 'Refill', accountTypes: Any, requireOn: 'None', mainHolderOnly: true, serialSensitive: true, nameRule: 'Application' },

  { id: FormFiles.Application_SWITCH_FAOL_FOL, title: 'FAOL to FOL 轉換表單_互動版', provideMethod: 'Refill', accountTypes: Any, requireOn: 'None', mainHolderOnly: true, serialSensitive: true, nameRule: 'Application' },
  { id: FormFiles.Application_SWITCH_FOL_FAOL, title: 'FOL to FAOL 轉換表單_互動版', provideMethod: 'Refill', accountTypes: Any, requireOn: 'None', mainHolderOnly: true, serialSensitive: true, nameRule: 'Application' },
  { id: FormFiles.Application_SWITCH_FAOL_FAOL, title: 'FAOL to FAOL 轉換表單_互動版', provideMethod: 'Refill', accountTypes: Any, requireOn: 'None', mainHolderOnly: true, serialSensitive: true, nameRule: 'Application' },
  { id: FormFiles.Application_SWITCH_AOL_AOL, title: 'AOL to AOL 轉換表單_互動版', provideMethod: 'Refill', accountTypes: Any, requireOn: 'None', mainHolderOnly: true, serialSensitive: true, nameRule: 'Application' },
  { id: FormFiles.Application_SWITCH_FOL_FOL, title: 'FOL to FOL 轉換表單_互動版', provideMethod: 'Refill', accountTypes: Any, requireOn: 'None', mainHolderOnly: true, serialSensitive: true, nameRule: 'Application' },

  { id: FormFiles.Application_SBS_BNP, title: 'FOL / FAOL Subscription Form', provideMethod: 'Refill', accountTypes: Any, requireOn: 'Provided', mainHolderOnly: true, serialSensitive: true, nameRule: 'Application' },
  { id: FormFiles.Application_RDM_BNP, title: 'FOL / FAOL Switching & Redemption Form', provideMethod: 'Refill', accountTypes: Any, requireOn: 'Provided', mainHolderOnly: true, serialSensitive: true, nameRule: 'Application' },
  { id: FormFiles.Application_Switch_BNP, title: 'FOL / FAOL Switching & Redemption Form', provideMethod: 'Refill', accountTypes: Any, requireOn: 'Provided', mainHolderOnly: true, serialSensitive: true, nameRule: 'Application' },

  {
    id: FormFiles.UndertakingLetter, title: 'UndertakingLetter', provideMethod: 'Refill', accountTypes: [AccountType.Joint], mainHolderOnly: true, requireOn: [
      'Provided',
    ],
    requireOriginal: 'Always',
    nameRule: 'UndertakingLetter',
    filename: `Undertaking Letter`
  },
  {
    id: FormFiles.Shareholder, title: 'JOINT SHAREHOLDER 共同持有人資料明細表', provideMethod: 'Refill', accountTypes: NaturalPerson, shareholderOnly: true, requireOn: [
      'Initial?',
      'NewAccount',
      'InactiveAccount',
    ],
    requireOriginal: 'Always',
    nameRule: 'Common',
    filename: `Joint shareholder investor's detail`
  },
  {
    // TODO 匯款證明要獨立出來
    id: FormFiles.PaymentProof, title: '認購匯款證明', provideMethod: 'Upload', accountTypes: Any, mainHolderOnly: true,
    multipleImages: true,
    requireOn: 'Hide', // TODO: ONLY SBS
    nameRule: 'Application',
  },
  {
    id: FormFiles.W8BEN, title: '個人 W-8BEN', provideMethod: 'Refill', accountTypes: NaturalPerson, requireOn: [
      'Initial?',
      'NewAccount',
      'InactiveAccount?',
      'W8Expired',
      'residence_address',
      'mailing_address',
      'nationality',
      'second_nationality',
    ],
    filename: 'W-8BEN',
    requireOriginal: 'Always',
    nameRule: 'Common',
  },
  {
    id: FormFiles.W8BEN_E, title: '企業 W-8BEN-E', provideMethod: 'Refill', accountTypes: CompanyAndNominee, requireOn: [
      'Initial?',
      'NewAccount',
      'InactiveAccount?',
      'W8Expired',
      'mailing_address',
      'business_location',
      'company_address',
    ],
    filename: 'W-8BEN-E',
    requireOriginal: 'Always',
    nameRule: 'Common',
  },
  // 舊版相容表單，僅供檢視
  { id: FormFiles.Attestation, title: 'Attestation Form', provideMethod: 'Refill', accountTypes: Any, description: '(Appendix B - Source of Wealth Attestation)', requireOn: 'None', filename: 'Attestation Form', requireOriginal: 'Always', nameRule: 'Common' },
  {
    id: FormFiles.AMLSupplement, title: 'AML Supplement', provideMethod: 'Refill', accountTypes: Any,
    requireOn: [
      'Initial?',
      'NewAccount',
      'InactiveAccount?',
    ],
    filename: 'AML Supplement',
    requireOriginal: 'Always',
    nameRule: 'Common',
  },
  {
    id: FormFiles.SelfCertification, title: 'Individual Self Certification 自我聲明表', provideMethod: 'Refill', accountTypes: NaturalPerson, requireOn: [
      'Initial?',
      'NewAccount',
      'InactiveAccount?',
      'residence_address',
      'mailing_address',
      'nationality',
      'second_nationality',
      'tax_payment_location',
      'second_tax_payment_location',
      'tax_id_number',
      'no_tin_reason',
      'no_tin_explain',
      'second_tax_id_number',
      'second_no_tin_reason',
      'second_no_tin_explain',
    ],
    filename: 'CRS',
    requireOriginal: 'Always',
    nameRule: 'Common',
  },
  {
    id: FormFiles.SelfCertification_E, title: 'Entity Self Certification 自我聲明表', provideMethod: 'Refill', accountTypes: CompanyAndNominee, requireOn: [
      'Initial?',
      'NewAccount',
      'InactiveAccount?',
      'mailing_address',
      'tax_payment_location',
      'second_tax_payment_location',
      'tax_id_number',
      'no_tin_reason',
      'no_tin_explain',
      'second_tax_id_number',
      'second_no_tin_reason',
      'second_no_tin_explain',
      'business_id_number',
      'business_location',
      'company_address',
    ],
    filename: 'CRS',
    requireOriginal: 'Always',
    nameRule: 'Common',
  },
  // 舊版相容表單，僅供檢視
  { id: FormFiles.ChangeParticulars, title: 'CHANGE OF PARTICULARS FORM', provideMethod: 'Refill', accountTypes: Any, mainHolderOnly: true, requireOn: 'None', filename: 'COP', requireOriginal: 'Always', nameRule: 'Common' },
  {
    id: FormFiles.ChangeWiringInstruction, title: 'Change of Wiring Instruction', provideMethod: 'Refill', accountTypes: Any,
    mainHolderOnly: true,
    requireOn: [
      'Initial?',
      'NewAccount',
      'InactiveAccount?',
      'bank_swift_code%',
      'beneficiary_bank_account_number%',
      'bank_account_name%',
      'bank_account_number%',
      'intermediary_bank_swift_code%',
      'second_intermediary_bank_account_name%',
      'second_intermediary_bank_account_number%',
    ],
    precondition: isExistenceHsbcClient,
    filename: 'COW',
    requireOriginal: 'Always',
    nameRule: 'Common',
  },
  {
    id: FormFiles.ChangeRegistration, title: 'Change of Registration', provideMethod: 'Refill', accountTypes: Any,
    mainHolderOnly: true, // 共同持有人共填一份
    requireOn: [
      'Initial?',
      'NewAccount',
      'InactiveAccount?',
      'phone_number',
      'fax_number',
      'email',
      'residence_address',
      'mailing_address',
      'company_address',
    ],
    precondition: isExistenceHsbcClient,
    filename: 'COR',
    requireOriginal: 'Always',
    nameRule: 'Common',
  },
  {
    id: FormFiles.BankAccount, title: '銀行帳戶結單副本', provideMethod: 'Upload', accountTypes: NaturalPerson,
    requireOn: [
      'bank_swift_code',
      'beneficiary_bank_account_number',
      'bank_account_name',
      'bank_account_number',
    ],
    filename: 'Bank Proof',
    nameRule: 'Common',
  },
  {
    id: FormFiles.Passport, title: '護照影本', provideMethod: 'Upload', accountTypes: NaturalPerson,
    requireOn: [
      'Initial?',
      'NewAccount',
      'InactiveAccount?',
      'passport_number',
      'passport_issuing_place',
      // 'phone_number+',
      'nationality',
      'second_nationality',
    ],
    multipleImages: true,
    description: [
      '* 請於影本上簽名，客戶所有文件之簽名樣式須一致',
      '* 請於基金行政管理人確認文件無誤後提供CTC副本或提供正本文件',
    ].join("\n"),
    filename: 'Passport Copy',
    nameRule: 'Common',
    requireCtc: 'NewAccount',
  },
  // {
  //   id: FormFiles.PersonalPhoneCertified, title: '聯絡電話更新證明', provideMethod: 'Upload', accountTypes: NaturalPerson, requireOn: ['phone_number', 'fax_number'],
  //   description: [
  //     '* 已更新電話號碼結單副本，或其他同時包含姓名與電話之第三方機構發行文件',
  //   ].join("\n"),
  //   filename: 'Phone Proof',
  // },
  {
    id: FormFiles.PersonalAddressCertified, title: '認購表上所填之地址證明', provideMethod: 'Upload', accountTypes: NaturalPerson, requireOn: [
      'Initial?',
      'NewAccount',
      'InactiveAccount?',
      'residence_address',
    ],
    multipleImages: true,
    description: [
      '* 三個月內之紙本水電費帳單、政府核發稅務繳費單，不接受銀行對帳單或電信費用帳單作為地址證明',
      '* 不接受電子帳單以及 P.O. Box 郵政信箱',
      '* 請註明認購者之英文姓名及英文地址。若有日期以民國年顯示，請註明西元日期',
      '* 請於基金行政管理人確認文件無誤後提供CTC副本或提供正本文件',
    ].join("\n"),
    filename: 'Address Proof',
    nameRule: 'Common',
    requireCtc: 'Copy',
    requireOriginal: 'CTC',
  },
  {
    id: FormFiles.BusinessAddressCertified, title: '公司地址證明', provideMethod: 'Upload', accountTypes: Company, requireOn: [
      'Initial?',
      'business_location',
      'company_address',
    ],
    multipleImages: true,
    description: [
      '公司遷址通知 / 最近三個月內地址證明（如公用服務結單）認證副本',
      '* 受監管之金融機構可從監管機構網頁（FATF管轄區或滙豐批准的司法管轄區）下載之新地址資料作為證明',
      '* 請於基金行政管理人確認文件無誤後提供CTC副本或提供正本文件',
    ].join("\n"),
    filename: 'II Address Proof',
    nameRule: 'Common',
    requireCtc: 'Copy',
    requireOriginal: 'CTC',
  },
  {
    id: FormFiles.BusinessLicense, title: '公司執照影本', provideMethod: 'Upload', accountTypes: Company, requireOn: [
      'Initial?',
      'NewAccount',
      'InactiveAccount?',
      'tax_id_number',
      'business_id_number',
      'business_location',
      'company_address',
    ],
    multipleImages: true,
    description: [
      '以下文件三擇一：',
      '* 公司執照影本',
      '* 營利事業登記證',
      '* 公司更改名稱證書',
    ].join("\n"),
    filename: 'Company search report',
    nameRule: 'Common',
  },
  {
    id: FormFiles.BusinessGoodStanding, title: 'Certificate of Good Standing 存續證明', provideMethod: 'Upload', accountTypes: Company, requireOn: [
      'Initial?',
      'NewAccount',
      'InactiveAccount?',
      'business_id_number',
      'business_location',
    ],
    description: [
      '* 請於基金行政管理人確認文件無誤後提供CTC副本或提供正本文件',
    ].join("\n"),
    filename: 'Certificate of Good Standing',
    nameRule: 'Common',
    requireCtc: 'Copy',
    requireOriginal: 'CTC',
  },
  {
    id: FormFiles.BusinessCharter, title: '公司章程', provideMethod: 'Upload', accountTypes: Company, requireOn: [
      'Initial?',
      'NewAccount',
      'InactiveAccount?',
      'tax_id_number',
      'business_id_number',
      'business_location*C',
      'company_address*C',
    ],
    multipleImages: true,
    description: [
      '* 請於基金行政管理人確認文件無誤後提供CTC副本或提供正本文件',
    ].join("\n"),
    filename: 'Articles of Incorporation',
    nameRule: 'Common',
    requireCtc: 'Copy',
    requireOriginal: 'CTC',
  },
  {
    id: FormFiles.BusinessCoI, title: 'Certificate of Incumbency (正本)', provideMethod: 'Upload', accountTypes: Company, requireOn: [
      'Initial?',
      'NewAccount',
      'InactiveAccount?',
      'tax_id_number+',
      'business_id_number+',
      'business_location+',
      'company_address+',
    ],
    multipleImages: true,
    description: [
      '律師／會計師／發證機構／外部秘書公司所出示之證明書',
      '* 董事姓名',
      '* 股東姓名及佔股比例',
      '* 公司註冊地址',
      '* 公司仍為註冊狀態，並非解散、清算或被吊銷執照',
      '* 須提供正本',
    ].join("\n"),
    filename: 'Certificate of Incumbency',
    nameRule: 'Common',
    requireOriginal: 'Always',
  },
  {
    id: FormFiles.BusinessMembers, title: '相關人員之護照影本，及居住地址證明', provideMethod: 'Upload', accountTypes: Company, requireOn: 'None',
    multipleImages: true,
    description: [
      '* 至少兩位以上董事 (包括常務董事／執行董事)',
      '* 授權簽署人員',
      '* 公司最終受益人 (佔公司股份 10%以上之受益人皆需提供)',
      '* 認購者需於影本上簽名，所有文件簽名樣式皆須一致',
      '* 三個月內之紙本水電費帳單、政府核發稅務繳費單，不接受銀行對帳單或電信費用帳單作為地址證明',
      '* 請於基金行政管理人確認文件無誤後提供CTC副本或提供正本文件',
    ].join("\n"),
    filename: 'Passport Copy & Address Proof',
    nameRule: 'Common',
    requireCtc: 'Always',
  },
  {
    id: FormFiles.BusinessMemberPassport, title: '相關人員之護照影本', provideMethod: 'Upload', accountTypes: Company, requireOn: [
      'Initial?',
      'NewAccount',
      'InactiveAccount?',
    ],
    multipleImages: false,
    multipleFiles: true,
    description: [
      '* 相關人員規定請見下方備註之說明',
      '* 認購者需於影本上簽名，所有文件簽名樣式皆須一致',
      '* 請於基金行政管理人確認文件無誤後提供CTC副本或提供正本文件',
    ].join("\n"),
    filename: 'Passport Copy',
    nameRule: 'Common',
    requireCtc: 'Always',
  },
  {
    id: FormFiles.BusinessMemberAddress, title: '相關人員之地址證明', provideMethod: 'Upload', accountTypes: Company, requireOn: [
      'Initial?',
      'NewAccount',
      'InactiveAccount?',
    ],
    multipleImages: false,
    multipleFiles: true,
    description: [
      '* 相關人員規定請見下方備註之說明',
      '* 三個月內之紙本水電費帳單、政府核發稅務繳費單，不接受銀行對帳單或電信費用帳單作為地址證明',
      '* 請於基金行政管理人確認文件無誤後提供CTC副本或提供正本文件',
    ].join("\n"),
    filename: 'Address Proof',
    nameRule: 'Common',
    requireCtc: 'Always',
  },
  {
    id: FormFiles.BusinessBoardResolution, title: '董事會決議正本，包含以下資訊', provideMethod: 'Upload', accountTypes: Company, requireOn: [
      'Initial?',
      'NewAccount',
      'InactiveAccount?',
    ],
    description: [
      '(1)授權投資',
      '(2)授權簽署人員名冊、簽名樣式以及公司章樣式/ASL Certification',
    ].join("\n"),
    filename: 'Register of shareholders',
    nameRule: 'Common',
  },
  {
    id: FormFiles.BusinessShareholders, title: '股東名冊', provideMethod: 'Upload', accountTypes: Company, requireOn: [
      'Initial?',
      'NewAccount',
      'InactiveAccount?',
    ],
    filename: 'Register of shareholders',
    nameRule: 'Common',
  },
  {
    id: FormFiles.BusinessDirectors, title: '董事名冊', provideMethod: 'Upload', accountTypes: Company, requireOn: [
      'Initial?',
      'NewAccount',
      'InactiveAccount?',
    ],
    filename: 'Register of directors',
    nameRule: 'Common',
  },
  {
    id: FormFiles.BusinessStatements, title: 'Financial Statements', provideMethod: 'Upload', accountTypes: Company, requireOn: [
      'Initial?',
      'NewAccount?',
      'InactiveAccount?',
    ],
    description: [
      '* 請於基金行政管理人確認文件無誤後提供CTC副本或提供正本文件',
    ].join("\n"),
    filename: 'Financial Statements',
    nameRule: 'Common',
    requireCtc: 'Always',
  },
  {
    id: FormFiles.NomineeLicense,
    title: 'License',
    provideMethod: 'Upload', accountTypes: Nominee, requireOn: [
      'Initial?',
      'NewAccount',
      'InactiveAccount?',
    ],
    nameRule: 'Original',
  },
  {
    id: FormFiles.NomineeMandate,
    title: 'Signed mandate/deed/board resolution authorizing the investment and conferring authority on those giving instructions',
    provideMethod: 'Upload', accountTypes: Nominee, requireOn: [
      'Initial?',
      'NewAccount',
      'InactiveAccount?',
    ],
    nameRule: 'Original',
  },
  {
    id: FormFiles.NomineeAssurance,
    title: 'Signed Written Assurance or AML Undertaking Letter',
    provideMethod: 'Upload', accountTypes: Nominee, requireOn: [
      'Initial?',
      'NewAccount',
      'InactiveAccount?',
    ],
    nameRule: 'Original',
  },
  {
    id: FormFiles.NomineeSignatures,
    title: 'Authorized signature list with specimen signatures',
    provideMethod: 'Upload', accountTypes: Nominee, requireOn: [
      'Initial?',
      'NewAccount',
      'InactiveAccount?',
    ],
    nameRule: 'Original',
  },
  {
    id: FormFiles.NomineeRepresentation,
    title: 'Written Representation from an independent department within the company (e.g. compliance, audit, human resources) confirming the authorized signors have the authority to act and their identities are verified',
    provideMethod: 'Upload', accountTypes: Nominee, requireOn: [
      'Initial?',
      'NewAccount',
      'InactiveAccount?',
    ],
    nameRule: 'Original',
  },
  {
    id: FormFiles.Others, title: '其他', provideMethod: 'Upload', accountTypes: Any, requireOn: [
      'Optional',
    ],
    multipleImages: false,
    multipleFiles: true,
    nameRule: 'Original',
  },
]

/** 兩陣列取交集 */
function intersection(array1: any[], array2: any[]) {
  return array1.filter(value => array2.includes(value))
}

interface FileRequireReasons {
  [id: string]: { file: FileDef, reason: string }
}

type FileRequirement = FileDef & { reason: string }

enum FileRequireType {
  /** 不需要上傳 */
  None = 0,
  /** 選填 */
  Optional = 1,
  /** 需要上傳 */
  Required = 2,
}

const currentApplicationFormKeys = new Set<FormFiles>([
  FormFiles.Application_SBS_BNP,
  FormFiles.Application_RDM_BNP,
  FormFiles.Application_Switch_BNP,
])

/** 新版套表存在時忽略同交易由後端一併回傳的舊版套表。 */
function getPreferredApplicationKeys(files: FormFile[], holderIndex = 0): Set<FormFiles> {
  const provided = files
    .filter(file => isFileProvide(file)
      && file.holder_index === holderIndex
      && getFileDef(file.key)?.nameRule === 'Application')
    .map(file => file.key)
  const current = provided.filter(key => currentApplicationFormKeys.has(key))
  return new Set(current.length ? current : provided)
}

/** 查詢用戶可上傳檔案；既有附件不依賴目前異動欄位，交易／註銷文件仍依原選取規則。 */
export function getUploadableForms(accountType: AccountType, changedFieldsOrConditions: string[], holderIndex = 0, fileProvides: FormFile[] = [], form?: Flexible<DealingMultiForm>, trade?: ITrade): FileRequirement[] {
  const fileRuleAccountType = getFileRuleAccountType(accountType, holderIndex)
  const hasFund = changedFieldsOrConditions.includes('HasFund')
  const isP = NaturalPerson.includes(fileRuleAccountType)
  const isE = Company.includes(fileRuleAccountType)
  const isC = isCountryTaiwan(form?.account.holder?.profile.business_location) === false
  const reasons: FileRequireReasons = {}
  const ignoreBankChanges = changedFieldsOrConditions.includes('IgnoreBankChanges') // 變更銀行資料僅限本次交易
  const preferredApplicationKeys = getPreferredApplicationKeys(fileProvides, holderIndex)

  function addReason(file: FileDef, reason: string): true {
    reasons[file.id] = {
      file,
      reason: [reasons[file.id]?.reason, reason].filter(Boolean).join('，'),
    }
    return true
  }

  function withReason(files: FileDef[]): FileRequirement[] {
    return files.map(f => ({ ...f, reason: reasons[f.id]?.reason ?? '未知' }))
  }
  function isProvided(file: FileDef) {
    return fileProvides.some(f => isFileProvide(f) && f.key === file.id && f.holder_index === holderIndex)
  }
  function isUploaded(file: FileDef) {
    return fileProvides.some(f => hasUploadedFile(f) && f.key === file.id && f.holder_index === holderIndex)
  }
  function checkCondition(file: FileDef, condition: string): FileRequireType {
    if (condition === 'Provided') return (addReason(file, '後端要求') && isProvided(file)) ? FileRequireType.Required : FileRequireType.None
    if (condition === 'Always') return addReason(file, '必須上傳') && FileRequireType.Required
    if (condition === 'Optional') return addReason(file, '選填檔案') && FileRequireType.Optional
    return changedFieldsOrConditions.reduce<FileRequireType>((req, field) => {
      const optionalCondition = condition.slice(-1) === '?' // 此條件為選填
      const optionalField = field.slice(-1) === '?' // 此異動欄位只需選填文件
      const optionalFlag = optionalCondition || optionalField
      const conditionKey = optionalCondition ? condition.slice(0, -1) : condition
      const fieldKey = optionalField ? field.slice(0, -1) : field
      // Nominee 為選填檔案
      if (condition.indexOf('Initial') === 0 && fieldKey === 'Nominee') {
        addReason(file, field)
        return set(true)
      }
      if (ignoreBankChanges && (condition.slice(-1) === '%')) return set(false) // 忽略銀行資訊變更
      if (conditionKey.indexOf(fieldKey) !== 0) return set(false) // 不符合條件
      if (optionalFlag) {
        addReason(file, "選填")
      }
      function set(val: boolean) { return req = Math.max(req, val ? (optionalFlag ? FileRequireType.Optional : FileRequireType.Required) : FileRequireType.None) }
      const suffix = conditionKey.substring(fieldKey.length)
      const [code1, code2] = suffix.split('')
      if (conditionKey.indexOf(fieldKey) !== 0) return set(false)
      const r1 = fieldKey
      if (code1 === undefined) return addReason(file, r1) && set(true)
      if (code1 === '+' && !hasFund) return set(false)
      if (code1 === '-' && hasFund) return set(false)
      const r2 = `${r1}，且${hasFund ? '有' : ' 無'}庫存`
      if (code2 === undefined) return addReason(file, r1) && set(true)
      if (code2 === 'P' && !isP) return set(false)
      if (code2 === 'E' && !isE) return set(false)
      if (code2 === 'C' && !isC) return set(false)
      return addReason(file, `${isP ? '自然人' : '法人'}帳戶${code1 === '*' ? r1 : r2} ${(code2 === 'C' && isC) ? '、公司註冊地不在台灣' : ''}`) && set(true)
    }, FileRequireType.None)
  }
  function byCondition(f: FileDef): FileRequireType {
    if (f.precondition && (f.precondition({ form, trade }) === false)) return FileRequireType.None
    if (f.id === FormFiles.ApplicationCancellation) {
      const hasCancellationTemplate = fileProvides.some(file => isFileProvide(file) && String(file.key).endsWith('_Cancel'))
      if (hasCancellationTemplate) {
        return addReason(f, '待註銷／已註銷交易') && FileRequireType.Required
      }
    }
    if (f.nameRule === 'Application' && changedFieldsOrConditions.includes('Amendment') && isProvided(f)) {
      return preferredApplicationKeys.has(f.id)
        ? addReason(f, '遞件修訂') && FileRequireType.Required
        : FileRequireType.None
    }
    if (f.requireOn === 'Hide') return FileRequireType.None // 匯款證明不在列表中出現
    if (f.nameRule !== 'Application' && f.nameRule !== 'Cancellation' && isUploaded(f)) {
      return addReason(f, '已上傳過') && FileRequireType.Required
    }
    if (f.requireOn instanceof Array) {
      return Math.max(...f.requireOn.map(condition => checkCondition(f, condition)))
    }
    else if (typeof f.requireOn === 'string') {
      return checkCondition(f, f.requireOn)
    }
    if (f.requireOn === 'Optional' || f.optional) return addReason(f, '選填檔案') && FileRequireType.Optional
    return addReason(f, '沒有特別設定條件') && FileRequireType.Required
  }
  let files: FileDef[] = []
  if (holderIndex === 0) {
    files = FileDefinitions.filter(f =>
      f.accountTypes.includes(fileRuleAccountType)
      && (f.shareholderOnly !== true || (accountType === AccountType.UGJoint && f.id === FormFiles.Shareholder))
    )
  } else {
    files = FileDefinitions.filter(f => f.accountTypes.includes(fileRuleAccountType) && f.mainHolderOnly !== true)
  }
  const filteredFiles = files.reduce<FileDef[]>((acc, file) => {
    let req = byCondition(file);
    if (req !== FileRequireType.None) {
      acc.push({ ...file, optional: req === FileRequireType.Optional });
    }
    return acc;
  }, [] as FileDef[]);

  return withReason(filteredFiles)
}

/** 取得用戶必須上傳的檔案 */
export function getRequiredForms(accountType: AccountType, changedFieldsOrConditions: string[], holderIndex = 0, fileProvides: FormFile[] = [], form?: Flexible<DealingMultiForm>, trade?: ITrade): FileRequirement[] {
  return getUploadableForms(accountType, changedFieldsOrConditions, holderIndex, fileProvides, form, trade)
    .filter(f => f.optional !== true)
}

/** 檢查每位持有人依現行規則要求的檔案是否皆已上傳。 */
export function hasAllRequiredFiles(accountType: AccountType, changedFields: string[][], files: FormFile[], form?: Flexible<DealingMultiForm>, trade?: ITrade, requirementFiles: FormFile[] = files): boolean {
  return changedFields.every((fields, holderIndex) =>
    getRequiredForms(accountType, fields, holderIndex, requirementFiles, form, trade).every(required =>
      files.some(file => file.key === required.id && file.holder_index === holderIndex && !!file.upload)
    )
  )
}

/** 改單必須重傳符合目前交易內容的套表；後端提供註銷套表時，另須上傳簽署正本。 */
export function hasRequiredAmendmentFiles(
  files: FormFile[],
  getExpectedFilename?: (key: FormFiles, holderIndex: number) => string,
  getExpectedCancellationFilename?: (key: FormFiles, holderIndex: number) => string,
): boolean {
  const hasMatchingUpload = (
    key: FormFiles,
    expectedFilename?: (key: FormFiles, holderIndex: number) => string,
  ) => files.some(file => {
    if (file.key !== key || !file.upload) return false
    const expected = expectedFilename?.(key, file.holder_index)
    if (!expected) return true
    const actual = file.upload.filename.replace(/\.[^.]+$/, '').replace(/_\(\d+\)$/, '')
    return actual === expected
  })
  const applicationKeys = getPreferredApplicationKeys(files)
  const applicationReady = applicationKeys.size > 0
    && [...applicationKeys].every(key => hasMatchingUpload(key, getExpectedFilename))
  const cancellationRequired = files.some(file => isFileProvide(file) && String(file.key).endsWith('_Cancel'))
  return applicationReady && (!cancellationRequired
    || hasMatchingUpload(FormFiles.ApplicationCancellation, getExpectedCancellationFilename))
}

/** W-8 已上傳時是否缺少簽名日期。 */
export function hasW8FileWithoutSignedDate(files: FormFile[]): boolean {
  return files.some(file =>
    [FormFiles.W8BEN, FormFiles.W8BEN_E].includes(file.key)
    && !!file.upload
    && !file.w8_signed_at
  )
}

/** 取得用戶可選填的檔案 */
export function getOptionalForms(accountType: AccountType, changedFieldsOrConditions: string[], holderIndex = 0, fileProvides: FormFile[] = [], form?: Flexible<DealingMultiForm>, trade?: ITrade): FileRequirement[] {
  return getUploadableForms(accountType, changedFieldsOrConditions, holderIndex, fileProvides, form, trade)
    .filter(f => f.optional === true)
}

/** 查詢檔案定義 */
export function getFileDef(fileId: string): FileDef | undefined {
  return FileDefinitions.find(fd => fd.id === fileId)
}

/**
 * 取得註銷頁可預覽的檔案；優先顯示後端產生的套表，歷史資料沒有套表時沿用最新上傳正本。
 */
export function getCancellationDisplayFile(files: FormFile[]): FormFile | undefined {
  return files.find(file => String(file.key).endsWith('_Cancel'))
    ?? [...files]
      .sort((a, b) => (b.file_sequence ?? 0) - (a.file_sequence ?? 0))
      .find(file => file.key === FormFiles.ApplicationCancellation && !!file.upload)
}

/** 取得已註銷交易由 agent 上傳的原交易申請表。 */
export function getCancellationOriginalFile(files: FormFile[]): FormFile | undefined {
  return files.find(file => String(file.key).startsWith('Application_')
    && !String(file.key).endsWith('_Cancel')
    && !!file.upload)
}

/** 單檔欄位固定覆蓋原檔；只有多檔欄位才產生流水號尾綴。 */
export function getUploadFileSuffix(multipleFiles: boolean, index: number, maxSequence: number | null): string {
  if (!multipleFiles) return ''
  if (index === 0) return maxSequence !== null ? `_(${maxSequence + 2})` : ''
  return maxSequence !== null ? `_(${maxSequence + index + 2})` : `_(${index + 1})`
}

/** 移除上傳檔；若同一筆也是下載套表，只清除 upload 並保留套表。 */
export function removeUploadedFile(files: FormFile[], key: FormFiles, holderIndex: number, filename?: string): void {
  const index = files.findIndex(file => file.key === key
    && file.holder_index === holderIndex
    && (!filename || file.upload?.filename === filename))
  if (index === -1) return
  const file = files[index]
  if (isFileProvide(file)) file.upload = undefined
  else files.splice(index, 1)
}

/** 單檔欄位重新上傳時，以新檔覆蓋同持有人的既有檔案並保留下載套表。 */
export function replaceUploadedFile(files: FormFile[], key: FormFiles, holderIndex: number, upload: NonNullable<FormFile['upload']>, fileSequence: number, tradeSequence = 0): void {
  const matches = files.filter(file => file.key === key && file.holder_index === holderIndex)
  const target = matches.find(isFileProvide) ?? matches[0]
  if (!target) {
    files.push({ key, holder_index: holderIndex, file_sequence: fileSequence, trade_sequence: tradeSequence, file_date: '', upload })
    return
  }
  Object.assign(target, { upload })
  matches.filter(file => file !== target).forEach(file => files.splice(files.indexOf(file), 1))
}

/** 有任何一個 HSBC ID 就認定為是舊客戶 */
export function isExistenceHsbcClient({ trade, form }: { form?: Flexible<DealingMultiForm>, trade?: ITrade }) {
  if (!trade && !form) return false
  if (form && (form.account.bnp_holder_id)) return true
  if (trade && (trade.bnp_holder_id)) return true
  // if (trade && (trade.hsbc_client_id || trade.hsbc_holder_id)) return true
  // if (form && (form.account.hsbc_client_id || form.account.hsbc_holder_id)) return true
  return false
}
